export default __webpack_public_path__ + "static/media/CSV.0176cfa4.svg";